import * as React from "react";
import * as Data from "./data";
import { NOT_SET } from "./need-approval-counter-updater";
import * as NeedSigningCounterUpdater from "./need-approval-counter-updater";
import LeftDrawer from "./left-drawer";

function needsCounters(user) {
  return !!(
    user &&
    (user.isInApprovalFlow ||
      user.canEditAcquisitionsReports ||
      user.canEditAccountingReports ||
      user.canEditReceptionReports)
  );
}

export default class LeftDrawerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      needSigningCounter: NOT_SET,
      newArticlesCounter: NOT_SET,
    };
  }

  updateCounters = (needSigningCounter, newArticlesCounter) => {
    this.setState({ needSigningCounter, newArticlesCounter });
  };

  componentDidMount() {
    if (needsCounters(this.props.user)) {
      NeedSigningCounterUpdater.register(this.updateCounters);
    }
  }

  componentDidUpdate(previousProps) {
    const userChanged = previousProps.user.id !== this.props.user.id;
    const eligibilityChanged =
      needsCounters(previousProps.user) !== needsCounters(this.props.user);
    if (userChanged || eligibilityChanged) {
      NeedSigningCounterUpdater.unregister();
      this.setState({
        needSigningCounter: NOT_SET,
        newArticlesCounter: NOT_SET,
      });
      if (needsCounters(this.props.user)) {
        NeedSigningCounterUpdater.register(this.updateCounters);
      }
      return;
    }
    if (
      previousProps.counterRevision !== this.props.counterRevision &&
      needsCounters(this.props.user)
    ) {
      NeedSigningCounterUpdater.fetchCounter(this.updateCounters);
    }
  }

  componentWillUnmount() {
    NeedSigningCounterUpdater.unregister();
  }

  render() {
    return (
      <LeftDrawer
        navDrawerOpen={this.props.navDrawerOpen}
        docked={this.props.docked}
        onRequestChange={this.props.onRequestChange}
        onNavigate={this.props.onNavigate}
        menus={Data.data(
          this.props.user,
          this.state.needSigningCounter,
          this.state.newArticlesCounter,
        )}
        username={this.props.username}
        email={this.props.userEmail}
      />
    );
  }
}
